var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLayers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99997 1.5625L1.88232 4.39583L7.99997 7.22917L14.1176 4.39583L7.99997 1.5625Z",
    stroke: "#393939",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.19741 6.98938L1.43183 7.74868C1.06476 7.90654 0.826904 8.26776 0.826904 8.66733C0.826904 9.0669 1.06476 9.42812 1.43183 9.58598L7.63252 12.2526C7.88474 12.3611 8.17045 12.3611 8.42267 12.2526L14.6234 9.58598C14.9904 9.42812 15.2283 9.0669 15.2283 8.66733C15.2283 8.26776 14.9904 7.90654 14.6234 7.74868L12.8578 6.98938L10.3266 8.07793L11.6971 8.66733L8.0276 10.2454L4.35808 8.66733L5.72858 8.07793L3.19741 6.98938Z",
    fill: "#393939"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.19765 11.21L1.43207 11.9693C1.06501 12.1272 0.827148 12.4884 0.827148 12.888C0.827148 13.2875 1.06501 13.6488 1.43207 13.8066L7.63277 16.4733C7.88498 16.5818 8.1707 16.5818 8.42291 16.4733L14.6236 13.8066C14.9907 13.6488 15.2285 13.2875 15.2285 12.888C15.2285 12.4884 14.9907 12.1272 14.6236 11.9693L12.858 11.21L10.3269 12.2986L11.6974 12.888L8.02784 14.4661L4.35832 12.888L5.72882 12.2986L3.19765 11.21Z",
    fill: "#393939"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayers);
export default __webpack_public_path__ + "static/media/Layers.afb99d0d24fd75ab0274155b3ffc1cc1.svg";
export { ForwardRef as ReactComponent };